<template>
	<div :class="style()" class="item-icon account-menu-container" @click="accountMenuAction">
		<div v-if="loggedIn" v-line-clamp:20="1" class="truncate-name user-name">
			{{ userName }}
		</div>
		<div v-if="isGuestLogin" class="guest">
			guest
		</div>
		<template v-if="showAccountIcon">
			<BaseIcon v-if="isNoLogin" icon="account" :isCustom="true" type="standard" />
		</template>
		<template v-if="!showAccountIcon">
			<div v-if="isNoLogin" v-line-clamp:20="1" class="truncate-name user-name">Sign In</div>
		</template>
	</div>
</template>

<script>
	import modalMixin from '@Mixin/modalMixin';
	import accountMixin from '@Mixin/accountMixin';
	import routeMixin from '@Mixin/routeMixin';
	import navigationMixin from '@Mixin/navigationMixin';
	const Login = (resolve) => {
		require.ensure([], () => {
			resolve(require('@/components/auth/Login.vue'));
		});
	};
	const ProfileEditor = (resolve) => {
		require.ensure([], () => {
			resolve(require('@/components/account/ProfileEditor.vue'));
		});
	};
	export default {
		mixins: [
			modalMixin,
			accountMixin,
			routeMixin,
			navigationMixin,
		],
		computed: {
			useAccountIconHeader() {
				const useAccountIcon = this.$appConstants.header.useAccountIcon;
				return (useAccountIcon === '1');
			},
			showAccountIcon() {
				if (this._isCheckout) {
					return false;
				}
				if (this.useAccountIconHeader) {
					return true;
				}
				return false;
			},
		},
		methods: {
			hideInRoutes() {
				const show = this.blackListRoute([]);
				return !show;
			},
			style() {
				return {
					'hide-account': this.hideInRoutes(),
				};
			},
			accountMenuAction() {
				const isGuestLogin = this.isGuestLogin;
				const loggedIn = this.isLoggedIn;
				const route = this.$route;
				this._setBackRoute(route);
				this._setCompletedRoute(route);
				if (isGuestLogin) {
					this._navigateToGuestForm();
					return;
				}
				if (loggedIn) {
					this._setBackRoute(null);
					this._setCompletedRoute(null);
					this.triggerModal({
						classes: 'global-modal',
						component: ProfileEditor,
						title: 'Profile',
						modalName: 'Profile',
						showCloseButton: true,
					});
					return;
				}
				this._navigateToSignIn();
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "globalStyles";
	@import 'commonStyle/nav-item';
	$accountNameMaxWidth: 92px;
	$accountNameOffset: 55px;

	.account-menu-container {
		width: calc(#{$navItemWidth} + 15px);
		&.hide-account {
			pointer-events: none;
			opacity: 0;
		}
		.truncate-name {
			width: 100%;
			overflow-x: hidden;
			text-overflow: ellipsis;
			text-align: right;
		}
		.user-name {
			position: relative;
			right: $accountNameOffset;
			min-width: $accountNameMaxWidth;
		}
		.guest {
			position: relative;
			right: 12px;
			padding: 1px 3px;
			border-radius: 4px;

			min-width: 3em;

			color: $landingPageBackground;
			background-color: $storeButtonColor;

			font-size: 1em;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/header/NavigationItems/AccountMenu.vue